/**
 * Client-side entity ids.
 *
 * Ids must be unique across peers editing the same board, so they are random
 * rather than sequential — two clients inserting at once would otherwise
 * collide and silently overwrite each other.
 */
const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';

export function newId(): string {
  const bytes = new Uint8Array(14);
  crypto.getRandomValues(bytes);
  let out = '';
  for (const byte of bytes) out += ALPHABET[byte % ALPHABET.length];
  return out;
}
